export default __webpack_public_path__ + "static/media/icon_address.21adf5f0.svg";